import { Link } from 'react-router-dom';
import { mainSiteUrl, categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 no-underline">
              <span className="font-heading text-xl font-bold text-foreground-900">
                VigorBuy <span className="text-primary-500">Spread</span>
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              Your trusted resource for spreadsheet guides, templates, and productivity strategies. Helping businesses make smarter data decisions.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-foreground-600 text-sm hover:text-primary-500 transition-colors">Home</Link></li>
              <li><Link to="/vigorbuy-spreadsheet-complete-guide" className="text-foreground-600 text-sm hover:text-primary-500 transition-colors">Complete Guide</Link></li>
              <li><a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-600 text-sm hover:text-primary-500 transition-colors">Main Store</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm uppercase tracking-wider">Categories</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-foreground-600 text-sm hover:text-primary-500 transition-colors whitespace-nowrap">{cat.name}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm uppercase tracking-wider">More Categories</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-foreground-600 text-sm hover:text-primary-500 transition-colors whitespace-nowrap">{cat.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">&copy; {new Date().getFullYear()} VigorBuy Spread. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors">Privacy Policy</a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}